import type { PolicyTransactionHistoryViewModel } from 'src/api/types/PolicyTransactionHistoryViewModel';
import type { SxProps, Theme } from '@mui/material/styles';

export function hasDetailSections(row: PolicyTransactionHistoryViewModel): boolean {
  return row.details !== null && row.details !== undefined && row.details.length > 0;
}

export function getTransactionHistoryRowKey(
  row: PolicyTransactionHistoryViewModel,
  index: number
): string {
  return [
    row.submissionId,
    row.transactionTypeCode,
    row.receivedDate,
    row.issueDate,
    row.transactionStatus,
    index,
  ]
    .filter((value) => value != null && value !== '')
    .join('-');
}

export function getStatusChipSx(transactionStatus?: string | null): SxProps<Theme> {
  const status = transactionStatus?.toLowerCase();
  const acceptedBackgroundFallback = 'rgba(200, 250, 214, 1)';
  const acceptedTextFallback = 'rgba(0, 120, 103, 1)';
  const rejectedBackgroundFallback = 'rgba(255, 86, 48, 0.16)';
  const rejectedTextFallback = 'rgba(183, 29, 24, 1)';

  return {
    fontFamily: (theme: Theme) => theme.typography.fontFamily,
    fontWeight: (theme: Theme) => theme.typography.fontWeightBold,
    fontSize: (theme: Theme) => theme.typography.caption.fontSize,
    lineHeight: (theme: Theme) => theme.typography.caption.lineHeight,
    letterSpacing: 0,
    textAlign: 'center',
    ...(status === 'accepted' && {
      bgcolor: (theme: Theme) =>
        theme.palette.transactionStatus?.accepted?.background ?? acceptedBackgroundFallback,
      color: (theme: Theme) =>
        theme.palette.transactionStatus?.accepted?.text ?? acceptedTextFallback,
      borderColor: (theme: Theme) =>
        theme.palette.transactionStatus?.accepted?.background ?? acceptedBackgroundFallback,
    }),
    ...(status === 'rejected' && {
      bgcolor: (theme: Theme) =>
        theme.palette.transactionStatus?.rejected?.background ?? rejectedBackgroundFallback,
      color: (theme: Theme) =>
        theme.palette.transactionStatus?.rejected?.text ?? rejectedTextFallback,
      borderColor: (theme: Theme) =>
        theme.palette.transactionStatus?.rejected?.background ?? rejectedBackgroundFallback,
    }),
  };
}
